
import { EmptyPlaceholder } from "@/components/interface/EmptyPlaceholder";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface EmptyStateProps {
  onAddProduct: () => void;
}

export const EmptyState = ({ onAddProduct }: EmptyStateProps) => {
  return (
    <EmptyPlaceholder>
      <EmptyPlaceholder.Icon name="products" />
      <EmptyPlaceholder.Title>Aucun produit</EmptyPlaceholder.Title>
      <EmptyPlaceholder.Description>
        Commencez par ajouter des produits à votre stock.
      </EmptyPlaceholder.Description>
      <Button onClick={onAddProduct} className="mt-4">
        <Plus className="w-4 h-4 mr-2" />
        Ajouter un produit
      </Button>
    </EmptyPlaceholder>
  );
};
